export default "__VITE_ASSET__yr3hA2Rq__"